import fordSeoUrl from '@/config/seo-config-url/branded/ford';

export default {
    openGraphImage: fordSeoUrl.openGraphImage,
    openGraphSiteName: 'Ford Blue Advantage',
    openGraphType: 'website',
};
